export const SOREWARDS_PROGRAM_FAMILIES = [
  'PROFID',
  'CHCOMA',
  'PARRAI',
  'INCINT',
  'OEUSOC',
  'CE',
  'NOELA',
  'NOELE',
  'RETR',
  'FETPAR',
  'MARPAC',
  'CV',
  'SCO',
  'NAIS',
  'CC',
  'FL',
  'AUTRES'
] as const

export const SOREWARDS_PROGRAM_VARIANTS = [
  '',
  '1',
  '2',
  '3',
  '_XP',
  '1_XP',
  '2_XP',
  '3_XP'
] as const

type SorewardsProgramFamily = typeof SOREWARDS_PROGRAM_FAMILIES[number]
type SorewardsProgramVariant = typeof SOREWARDS_PROGRAM_VARIANTS[number]
export type SorewardsProgramType = `${SorewardsProgramFamily}${SorewardsProgramVariant}` | 'TOP_UP'

export interface SorewardsProgramTypeGroup {
  family: SorewardsProgramFamily | 'TOP_UP'
  types: SorewardsProgramType[]
}

export const SOREWARDS_PROGRAM_TYPE_GROUPS: SorewardsProgramTypeGroup[] = [
  ...SOREWARDS_PROGRAM_FAMILIES.map((family) => ({
    family,
    types: SOREWARDS_PROGRAM_VARIANTS.map(
      (variant) => `${family}${variant}` as SorewardsProgramType
    )
  })),
  { family: 'TOP_UP', types: ['TOP_UP'] }
]

const FAMILIES_LONGEST_FIRST = [...SOREWARDS_PROGRAM_FAMILIES].sort(
  (a, b) => b.length - a.length
)

type SorewardsTranslate = (key: string) => string

export function familyFor(programType: string | null | undefined): string | null {
  if (!programType) return null
  if (programType === 'TOP_UP') return 'TOP_UP'

  for (const family of FAMILIES_LONGEST_FIRST) {
    if (!programType.startsWith(family)) continue

    const rest = programType.slice(family.length)
    if ((SOREWARDS_PROGRAM_VARIANTS as readonly string[]).includes(rest)) {
      return family
    }
  }

  return null
}

export function familyLabelFor(
  family: string,
  t: SorewardsTranslate,
  te?: (key: string) => boolean
): string {
  const key = `sorewardsPrograms.families.${family}`
  if (te && !te(key)) return family
  return t(key)
}

export function labelFor(
  programType: string | null | undefined,
  t: SorewardsTranslate,
  te?: (key: string) => boolean
): string {
  if (!programType) return ''

  const family = familyFor(programType)
  if (!family) return programType

  return familyLabelFor(family, t, te)
}
